import { IAuthServiceV2 } from '@volkswagen-onehub/authservice';
import { LocaleServiceV1 } from '@volkswagen-onehub/locale-service';

export interface IDocumentConsentResponse {
    readonly consentRequired?: boolean;
    readonly versionDetails?: {
        readonly id: string;
        readonly versionId: string;
        readonly locale: string;
        readonly title: string;
        readonly text: string;
        readonly disclaimer: string;
    };
    readonly consent?: {
        readonly id: string;
        readonly userId: string;
        readonly decision: boolean;
        readonly versionDetailsId: string;
        readonly collector: string;
        readonly updatedAt: string;
    };
}

export class DocumentConsentClient {
    private readonly locale: string;

    private readonly resourceHostId;

    private getGdcType = (isWcar: boolean) => (isWcar ? `myvw-wcar-${this.stage}` : `myvw-mbb-${this.stage}`);

    constructor(
        private readonly authServiceWeConnect: IAuthServiceV2,
        private readonly localeService: LocaleServiceV1,
        private readonly stage: string,
    ) {
        this.locale = `${this.localeService.language}-${this.localeService.countryCode}`;

        /**
         * The condition below is a special handling of Norwegian
         * market. The language-country code of this market
         * is 'no-NO', but this particular API would return
         * 'No concents for this language'. Therefore, we ask for
         * 'nb-NO' language-country code for this case.
         */
        if (this.localeService.language === 'no' && this.localeService.countryCode === 'NO') {
            this.locale = 'nb-NO';
        }

        this.resourceHostId = `myvw-document-consent-${stage}`;
    }

    public async getDocumentConsentRequired(
        isWcar: boolean,
        documentId: string,
        userId: string,
    ): Promise<IDocumentConsentResponse | undefined> {
        const documentConsentUrl = 'api/v2/consents/required';
        let response = await this.authServiceWeConnect.get(
            this.resourceHostId,
            `${documentConsentUrl}?gdc=${this.getGdcType(isWcar)}&document-id=${documentId}&user-id=${userId}&locale=${
                this.locale
            }`,
        );

        if (!response.ok) {
            throw new Error();
        }
        return (await response.json()) as IDocumentConsentResponse;
    }
}
